import {
  useMutation as useMutationCore,
  useQuery as useQueryCore,
  gQuery,
  gMutate,
  createClient,
  objToGql,
} from '@archre2/react-core';

import config from '../../../config';

const configuration = { uri: config.API.URI, timeout: config.API.TIMEOUT };

// Normal GraphQL client
export const client = createClient(configuration);

// GraphQL client used for uploading files, using multipart forms
export const uploadClient = createClient(configuration, true);

export const query = gQuery(client);
export const mutate = gMutate(client);
export const fileUpload = gMutate(uploadClient);
export const useMutation = (mutation, config = {}) =>
  useMutationCore(mutation, config, client, uploadClient);
export const useQuery = (queryDef, config = {}) =>
  useQueryCore(queryDef, config, client);

export { objToGql };
